<template>
  <picture v-if="imageFiles.length">
    <source
      v-for="(imageFile, index) in imageFiles.slice(0, -1)"
      :key="`${imageFile.file.url}-${index}`"
      :type="`image/${imageFile.file_format}`"
      :srcset="imageFile.file.url"
    >
    <source
      :type="`image/${lastImageFile.file_format}`"
      :srcset="lastImageFile.file.url"
    >
    <img
      v-bind="$attrs"
      :src="lastImageFile.file.url"
      :class="imgClass"
      :style="imgStyle"
      :data-lazy-src="dataLazySrc ? lastImageFile.file.url : undefined"
      :alt="imgAlt"
    >
  </picture>
  <img
    v-else
    v-bind="$attrs"
    :src="fallbackSrc"
    :class="imgClass"
    :style="imgStyle"
    :data-lazy-src="dataLazySrc ? fallbackSrc : undefined"
    :alt="imgAlt"
  >
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import {
  LPU_NO_AVATAR_URL,
  type LpuLogoImageFile,
} from 'src/utils/getLpuAvatarUrl'

const props = defineProps<{
  files?: LpuLogoImageFile[]
  imgClass?: string
  contain?: boolean
  dataLazySrc?: boolean
  fallbackSrc?: string
  alt?: string
}>()

const imageFiles = computed(() => (props.files || []).filter(imageFile => Boolean(imageFile?.file?.url)))
const lastImageFile = computed(() => imageFiles.value[imageFiles.value.length - 1])
const fallbackSrc = computed(() => props.fallbackSrc || LPU_NO_AVATAR_URL)
const imgAlt = computed(() => props.alt || '')
const imgStyle = computed((): { objectFit: 'contain' } | undefined => (
  props.contain ? { objectFit: 'contain' } : undefined
))
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
}
</script>
